module.exports = __webpack_public_path__ + "static/media/mix.9b8a6b00.svg";